import React, { useEffect } from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import { useTheme } from '../../theme/theme-provider';
import AboutPhoto from '../../static/images/photo1704392396_2_1.jpeg';
import ThemeAmbientOverlay from '../theme-ambient-overlay/ThemeAmbientOverlay';

const About = ({ sendPage }) => {
	const { themeMode } = useTheme();
	const isDark = themeMode === 'dark';
	const accentGold = isDark ? '#F2D399' : '#1f1f1f';

	useEffect(() => {
		sendPage('about');
		window.scrollTo(0, 0);
	}, []);

	return (
		<Box
			sx={{
				backgroundColor: 'var(--background-color)',
				minHeight: '100vh',
				pt: { xs: 2, md: 2 },
				pb: { xs: 6, md: 8 },
				position: 'relative',
				overflow: 'hidden'
			}}
		>
			<ThemeAmbientOverlay speed={30} />
			<Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
				<Typography
					align="center"
					variant="h2"
					color={isDark ? 'white' : 'rgba(22,22,22,0.94)'}
					sx={{
						fontFamily: 'Light-1',
						textShadow: isDark ? '4px 4px black' : '2px 2px rgba(255,255,255,0.65)',
						fontSize: { xs: '2.4rem', sm: '3rem', md: '3.5rem' },
						mb: 4
					}}
				>
					About
				</Typography>

				<Box
					sx={{
						position: 'relative',
						border: isDark ? '1px solid rgba(242, 211, 153, 0.25)' : '1px solid rgba(0,0,0,0.1)',
						boxShadow: isDark ? '0 12px 30px rgba(0,0,0,0.25)' : '0 10px 24px rgba(0,0,0,0.12)',
						borderRadius: 2,
						p: { xs: 3, md: 4 },
						'&::before': {
							content: '""',
							position: 'absolute',
							top: 0, left: 0, right: 0, bottom: 0,
							background: isDark
								? 'linear-gradient(90deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.7) 15%, rgba(0,0,0,0.7) 85%, rgba(0,0,0,0.05) 100%)'
								: 'linear-gradient(90deg, rgba(255,250,244,0.1) 0%, rgba(255,250,244,0.92) 15%, rgba(255,250,244,0.92) 85%, rgba(255,250,244,0.1) 100%)',
							backdropFilter: 'blur(8px)',
							borderRadius: 2,
							zIndex: -1
						}
					}}
				>
					{/* Portrait — natural size, overlays on top */}
					<Box sx={{
						position: 'relative',
						width: '100%',
						borderRadius: 2,
						overflow: 'hidden',
						mb: 3,
						border: isDark ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.12)',
						boxShadow: isDark ? '0 12px 40px rgba(0,0,0,0.6)' : '0 8px 28px rgba(0,0,0,0.12)',
					}}>
						<Box component="img" src={AboutPhoto} alt="Vadym D"
							sx={{
								width: '100%',
								height: 'auto',
								display: 'block',
								filter: isDark ? 'brightness(0.75)' : 'brightness(0.88)',
							}}
						/>
						<Box sx={{
							position: 'absolute', inset: 0, pointerEvents: 'none',
							backgroundImage: [
								'repeating-linear-gradient(45deg, rgba(0,0,0,0.18) 0 1px, transparent 1px 10px)',
								'repeating-linear-gradient(-45deg, rgba(0,0,0,0.07) 0 1px, transparent 1px 16px)',
							].join(','),
						}} />
						<Box sx={{
							position: 'absolute', bottom: 0, left: 0, right: 0,
							px: 2, py: 1.2, background: 'rgba(0,0,0,0.62)', backdropFilter: 'blur(4px)',
							display: 'flex', justifyContent: 'center',
						}}>
							<Typography sx={{
								fontFamily: '"Courier New", monospace', fontWeight: 600,
								fontSize: '0.7rem', letterSpacing: '0.18em',
								color: 'rgba(255,255,255,0.62)', textTransform: 'uppercase',
							}}>[ Distorise ]</Typography>
						</Box>
					</Box>
					<Stack spacing={2.2}>
						<Typography color={isDark ? 'white' : '#1a1a1a'} sx={{ fontFamily: '"Courier New", monospace', fontWeight: 600, lineHeight: 1.8 }}>
							Hi, I&apos;m Vadym D., a composer, producer, sound designer, and software engineer based in Lviv, Ukraine.
						</Typography>
						<Typography color={isDark ? 'white' : '#1a1a1a'} sx={{ fontFamily: '"Courier New", monospace', fontWeight: 600, lineHeight: 1.8 }}>
							I create music under the name Distorise, combining cinematic storytelling, electronic production, and detailed sound design. My work ranges from artist releases and personal projects to music and sound design for brands, films, games, and digital experiences.
						</Typography>
						<Typography color={isDark ? 'white' : '#1a1a1a'} sx={{ fontFamily: '"Courier New", monospace', fontWeight: 600, lineHeight: 1.8 }}>
							My background in technology has shaped the way I approach creative work: understanding systems, solving problems, and building experiences that connect with people. Whether I&apos;m composing music, designing sounds, or developing a website, I&apos;m interested in how technology and creativity come together to tell better stories.
						</Typography>
						<Typography color={isDark ? 'white' : '#1a1a1a'} sx={{ fontFamily: '"Courier New", monospace', fontWeight: 600, lineHeight: 1.8 }}>
							As Distorise, I primarily create cinematic Drum &amp; Bass and dark electronic music inspired by technology, movement, and human experience. Alongside my artist work, I collaborate with brands and visual creators to develop original music and sound design that supports storytelling and strengthens emotional connection.
						</Typography>

					</Stack>
				</Box>
			</Container>
		</Box>
	);
};

export default About;
